<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      海上世界站<br>
站点介绍<br>
车站位于工业三路和南海大道的交叉口处,沿南海大道南北向敷设。车站设置有 4 个出入口，其中 H 口为主要紧急出入口,有盲道及垂直电梯通往地面；E 口为备用紧急出入口。付费区中部与2号线海上世界相连。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:08	23:04	12号线	4分钟	8分钟<br>
海上田园东	06:43	00:07	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:12	23:04	12号线	8分钟	8分钟<br>
海上田园东	06:45	00:07	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
E出入口:<br>
南海大道东侧<br><br>
F出入口:<br>
南海大道东侧、荔枝公园(南海大道)<br><br>
G出入口:<br>
南海大道西侧<br><br>
H出入口:<br>
南海大道西侧、深圳市蛇口人民医院综合门诊部<br><br>
公交换乘信息<br><br>
H出入口:<br>
公交站名： 明华中心站<br>
70<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>